import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    MenuItem, Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledButtonBlack
} from "../../../styles/MyStyles";
import {GetEnumMenuItems} from "../../../logic/EnumHelper";

const AssetEditPage = () => {
    const { assetId } = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [asset, setAsset] = useState({
        name: '',
        type: '',
        id: 0,
        network: ''
    });

    useEffect(() => {
        const fetchAsset = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (assetId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_ASSETS_URL}/${assetId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        const fetchedAsset = data.data;
                        setAsset(fetchedAsset);
                    } else {
                        console.log('Fetch asset failed.');
                    }
                } else {
                    // Create mode, initialize asset with empty values
                    setAsset({
                        name: '',
                        type: '',
                        id: 0,
                        network: ''
                    });
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchAsset();
    }, [assetId]);

    const validateForm = () => {
        let newErrors = {};

        // Validate name field
        if (!asset.name.trim()) {
            newErrors.name = 'Name is required.';
        }

        // Validate type field
        if (asset.type === '') {
            newErrors.type = 'Type is required.';
        }

        if (asset.type === 1 && asset.network === '') {
            newErrors.network = 'Network is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setAsset({
            ...asset,
            [event.target.name]: event.target.value,
        });
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_ASSETS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(asset),
                }
            );
            if (response.ok) {
                console.log('Asset updated successfully.');
                handleGoBack();
            } else {
                console.log('Update asset failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleDelete = async () => {
        try {
            console.log(asset);
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_ASSETS_URL}/${asset.id}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                console.log('Asset deleted successfully.');
                handleGoBack();
            } else {
                console.log('Delete asset failed.');
            }
        } catch (error) {
            // Handle network errors or other exceptions
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {assetId ? 'Edit Asset' : 'Create Asset'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
                {(assetId && <StyledButtonBlack variant="contained" onClick={handleDelete}>
                    Delete
                </StyledButtonBlack>)}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Name</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="name"
                                label="Name"
                                value={asset.name}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.name}
                                helperText={errors.name}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={asset.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {GetEnumMenuItems('assetType')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    {asset.type === 1 && (
                        <TableRow>
                            <StyledTableCell style={{ width: '10%' }}>Network</StyledTableCell>
                            <TableCell style={{ width: '90%' }}>
                                <TextField
                                    name="network"
                                    label="Network"
                                    select
                                    value={asset.network}
                                    onChange={handleFieldChange}
                                    fullWidth
                                    required
                                    error={!!errors.network}
                                    helperText={errors.network}
                                >
                                    {GetEnumMenuItems('chainalysisNetwork')}
                                </TextField>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Container>
    );
};

export default AssetEditPage;
